'use client';

import { RefObject, useEffect, useState } from 'react';

export const useSvgChartDimensions = (ref: RefObject<SVGSVGElement | null>, width?: number, height?: number) => {
  const [dimensions, setDimensions] = useState({ width: width || 0, height: height || 0 });

  useEffect(() => {
    const container = ref.current;
    if (!container) return;

    const updateDimensions = () => {
      setDimensions({
        width: width ?? container.getBoundingClientRect().width,
        height: height ?? container.parentElement?.getBoundingClientRect().height ?? 200,
      });
    };

    updateDimensions();
    const observer = new ResizeObserver(updateDimensions);
    observer.observe(container);
    return () => observer.disconnect();
  }, [ref, width, height]);

  return dimensions;
};
